import { useTranslation } from '@/hook';
import Typography from '@/components/shared/typography/typography.component';
import { Step } from '@/components/purchaseCarSteps/step';
import {
    PurchaseCarStep1,
    PurchaseCarStep2,
    PurchaseCarStep3,
} from '../../../public/Images';
import { FC, Fragment } from 'react';

export const PurchaseCarSteps: FC = () => {
    const { t } = useTranslation();
    const renderMarkup = ({ html }) => {
        const splitHtml = html.split('<br/>');
        return (
            <div className={'inline'}>
                {splitHtml.map((part, index) => (
                    <Fragment key={index}>{part}</Fragment>
                ))}
            </div>
        );
    };
    return (
        <div
            className={`flex  
               flex-col
             gap-4 md:gap-3 py-4 md:px-0 md:col-span-3 w-full h-full`}
        >
            <div className={'inline'}>
                <Typography
                    variant={'subtitle2SemiBold'}
                    component="span"
                    className={'inline'}
                >
                    {renderMarkup({ html: t('purchaseSteps.titlePt1') })}
                </Typography>
                <Typography
                    variant={'subtitle2SemiBold'}
                    className={'text-primary-700'}
                    component="span"
                >
                    {renderMarkup({ html: t('purchaseSteps.titlePt2') })}
                </Typography>
            </div>

            <div
                className={`grid gap-2 grid-rows-3 md:grid-rows-1 md:grid-cols-3  
                `}
            >
                <Step
                    src={PurchaseCarStep1}
                    title={t('purchaseSteps.step1.title')}
                    subtitle={t('purchaseSteps.step1.subtitle')}
                />
                <Step
                    src={PurchaseCarStep2}
                    title={t('purchaseSteps.step2.title')}
                    subtitle={t('purchaseSteps.step2.subtitle')}
                />
                <Step
                    src={PurchaseCarStep3}
                    title={t('purchaseSteps.step3.title')}
                    subtitle={t('purchaseSteps.step3.subtitle')}
                />
            </div>
        </div>
    );
};
